import CustomModal from '../../../../../components/Modal/CustomModal';
import {IconCondonation, IconPay, PersonChip} from '../../../../../components/buttons/IconButtons';
import React from 'react';
import CustomCard from '../../../../../components/CustomCard';
import BannerComponentUser from './Components/BannerComponentUser';
import { EMPTY_VALUES } from '../../../../../Apis/functions';
import { userType } from '../../../../../enums/userTypeEnum';
import FineStatusStepper from '../SubComponents/StatusFines';
import AmountComponent from './Components/AmountComponent';
import { CustomTextField } from '../../../../../components/CustomTextField';
import CustomPhotoPicker from '../../../../../components/PhotoPicker/CustomPhotoPicker';
import { ACTION_MODEL } from '../../../../../Helpers/ActionModel';
import { FILE_TYPE } from '../../../../../Helpers/fileType';
import { size50MB } from '../../../../../constant/variable';
import PaymentModalApp from '../Functionality/PaymentModalApp';
import { TYPE_PAYMENT } from '../Model/Model';
import ComponentHeaderBack from './Components/ComponentHeaderBack';
import {STATUS_MODEL} from '../../../../../enums/statusEnum';

/**
 *
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 * s
 */
const PaymentModal = (
    {
        show, onHide,
        paymentTypeSelect,
        setShowConfirmationPay,
        setModified
    }
) => {

    const {
        t,
        photoPicker, setPhotoPicker,
        disabled, setDisabled,
        item, setItem,
        emptyFields, setEmptyFields,
        handleChange,
        trafficData,
        handleConfirm,
        emptyDescription
    } = PaymentModalApp({ paymentTypeSelect, setShowConfirmationPay, onHide, setModified });

    return (
        <CustomModal
            show={show}
            size='lg'
            onHide={() => {
                onHide();
            }}
            onConfirm={() => {
                handleConfirm();
            }}
            closeButton={false}
            confirmButton={true}
            cancelButton={true}
            classNameBody={'p-0 m-0'}
        >
            <>
                <ComponentHeaderBack
                    onHide={() => {
                        onHide();
                    }}
                    title={paymentTypeSelect === TYPE_PAYMENT.CONDONATION ? 'condone_fine' : 'payment'}
                    trafficData={trafficData}
                    icon={paymentTypeSelect === TYPE_PAYMENT.CONDONATION ? <div><IconCondonation width={24} height={24} className="icon-color-general-950" /></div> : <div><IconPay width={24} height={24} className="icon-color-general-950" /></div>}
                />
                <div className="mb-3">
                <CustomCard classes={"w-100"} classCard={'card-border-8px'} classContent={'p-0 m-0'}>
                    <div className="d-flex justify-content-between align-items-center m-3">
                        <BannerComponentUser
                            title={trafficData?.fullName || EMPTY_VALUES.DEFAULT}
                            nameChip={userType[trafficData?.userTypeId] ? t(userType[trafficData?.userTypeId]) : EMPTY_VALUES.DEFAULT}
                            icon={<PersonChip width={32} height={32} />}
                        />
                        <FineStatusStepper
                            statusId={trafficData?.statusId}
                            statusScheduleId={trafficData?.statusScheduleId}
                            finePaymentDate={trafficData?.finePaymentDate}
                            createdAtFine={trafficData?.createdAt}
                            discountDate={trafficData?.discountDate}
                            paymentDate={trafficData?.paymentDate}
                            suspendedAccountDate={trafficData?.suspendedAccountDate}
                            discountApplied={trafficData?.discountApplied}
                            t={t}
                        />
                    </div>
                    <div className="border-bottom-shades-300" />
                    <CustomCard classes={"w-100"} classCard={'border-0'}>
                        <div className="row d-flex justify-content-end">
                            <AmountComponent
                                folio={trafficData?.folio}
                                subtotal={trafficData?.fineAmount}
                                discount={trafficData?.discountAmount}
                                penalty={trafficData?.penaltyAmount}
                                paymentType={paymentTypeSelect}
                                total={trafficData?.paidAmount}
                                isPaid={trafficData?.statusId === STATUS_MODEL.PAID }
                            />
                        </div>
                        <div>
                            <p className="text-center fs-14px ibl-font-w-700 font-color-general-950 py-3">
                                {paymentTypeSelect === TYPE_PAYMENT.CONDONATION ? t('justification_required').toUpperCase() : t('payment_concept').toUpperCase()}
                            </p>

                            <div className="col-12">
                                <CustomTextField
                                    id="txt_pm_description"
                                    length={128}
                                    name="description"
                                    value={item.description}
                                    trans="description"
                                    type="text"
                                    onChange={handleChange}
                                    multiline={true}
                                    required={paymentTypeSelect === TYPE_PAYMENT.CONDONATION}
                                    emptyFields={emptyDescription}
                                />
                            </div>

                            <p className="text-center fs-14px ibl-font-w-700 font-color-general-950 py-3">
                                {`${t('attach_evidence').toUpperCase()} ${paymentTypeSelect === TYPE_PAYMENT.CONDONATION ? '(' + t('required').toUpperCase() + ')' : ''}`}
                            </p>

                            <div className="col-12">
                                <CustomPhotoPicker
                                    id='fu_pm_evidences_payment'
                                    photoPicker={photoPicker}
                                    setPhotoPicker={setPhotoPicker}
                                    actionModel={ACTION_MODEL.CREATE}
                                    accept={{ ...FILE_TYPE.FILES }}
                                    classWith={'w-100'}
                                    disabled={disabled}
                                    showPreview={false}
                                    emptyFields={emptyFields}
                                    required={true}
                                />
                            </div>
                        </div>
                    </CustomCard>
                </CustomCard>
                </div>
            </>
        </CustomModal>
    );

}

export default PaymentModal
